//changes from haseeb.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UsePortalApi } from "../../../utils/UsePortalApi";

export const PatientAlerts = createAsyncThunk(
  "PatientAlerts",
  async (payload, { dispatch, getState }) => {
    try {
      dispatch(gettingPatientAlerts(""));
      const response = await UsePortalApi(
        `Patient/PatientAlerts`,
        "Post",
        payload,
        true
      );
      if (response) {
        console.log(response , "response")
        response[0].hasOwnProperty('entry') ? dispatch(gettingPatientAlertsSuccess(response[0].entry)) : dispatch(gettingPatientAlertsFailed())

      } else {
        dispatch(
          gettingPatientAlertsFailed(
            response?.errorMessage
          )
        );
      }
    } catch (error) {
      dispatch(gettingPatientAlertsFailed(error));
    }
  }
);
const PatientAlertsSlice = createSlice({
  name: "PatientAlerts",
  initialState: {
    Reminders: null,
    isGettingReminders: false,
    errorReminders: false,
  },
  reducers: {
    gettingPatientAlerts: (state, action) => {
      state.Reminders = null;
      state.isGettingReminders = true;
      state.errorReminders = false;
    },
    gettingPatientAlertsSuccess: (state, action) => {
      state.Reminders = action.payload;
      state.isGettingReminders = false;
      state.errorReminders = false;
    },
    gettingPatientAlertsFailed: (state, action) => {
      state.Reminders = null;
      state.isGettingReminders = false;
      state.errorReminders = true;
    },
    gettingPatientAlertsClear: (state, action) => {
      state.Reminders = null;
      state.isGettingReminders = false;
      state.errorReminders = false;
    },
  },
});
export const {
  gettingPatientAlerts,
  gettingPatientAlertsSuccess,
  gettingPatientAlertsFailed,
  gettingPatientAlertsClear,
} = PatientAlertsSlice.actions;
export default PatientAlertsSlice.reducer;
